<nav [attr.aria-label]="locales.common.navigation | localize">
	<ud-mega-menu [items]="merchantStore.items()" [menuLabel]="locales.common.menu | localize" (menuPressed)="showVerticalNav()" ngSkipHydration="true">
		@if (logo(); as logo) {
			<ng-template udTemplate="start">
				<a [routerLink]="['/']" [attr.aria-label]="locales.common.homepage | localize">
					<img class="logo" [src]="logo" [alt]="locales.common.logo | localize" />
				</a>
			</ng-template>
		}
		<ng-template udTemplate="end">
			<span class="megamenu-icon-button flex flex-row relative" [hidden]="hideCheckout()">
				@if (profile()) {
					<button class="cart-btn flex justify-center items-center" (click)="profileOptions.toggle($event)">
						<i aria-hidden="true" class="fas fa-user"></i>
					</button>
				}
				<button
					class="cart-btn cart-btn-xs flex justify-center items-center"
					[attr.aria-label]="locales.common.viewCart | localize"
					(click)="viewCart()"
				>
					<div class="far fa-cart-shopping">
						@if (basket()?.totalItems(); as totalItems) {
							<span class="cart-count subtitle-2 flex justify-center items-center">{{ totalItems }}</span>
						}
					</div>
				</button>
				<button
					class="far fa-cart-shopping cart-btn cart-btn-md flex justify-center items-center"
					[title]="locales.common.viewCart | localize"
					[attr.aria-label]="locales.common.viewCart | localize"
					(click)="showMiniCart($event)"
					aria-haspopup="true"
					[attr.aria-expanded]="enableMiniCart()"
					aria-controls="header-mini-cart"
					(keydown.enter)="showMiniCart($event)"
				>
					@if (basket()?.totalItems(); as totalItems) {
						<span class="cart-count subtitle-2 flex justify-center items-center">{{ totalItems }}</span>
					}
				</button>
				<ud-menu #profileOptions appendTo="body" isPopup="true" [items]="profileMenu()" />
				@if (enableMiniCart()) {
					<ud-card id="header-mini-cart" class="mini-cart" [floating]="true" (click)="hideMiniCart()">
						<ecom-mini-cart
							[buttonLabel]="locales.common.viewCart | localize"
							[cart]="basket()"
							productPath="/product/:productId"
							(viewCart)="viewCart()"
						/>
					</ud-card>
				}
			</span>
		</ng-template>
	</ud-mega-menu>
</nav>
@defer (on idle) {
	<ud-banners [shadowed]="true" [closeLabel]="locales.common.close | localize" />
	<ud-floating-banners [shadowed]="true" [closeLabel]="locales.common.close | localize" />
}
<main>
	<router-outlet></router-outlet>
</main>

@let merchantDisplayName = merchantStore.merchant()?.name() ?? 'accesso Technology Group, plc';
@let copyright = ['©', year, merchantDisplayName].join(' ');

<ud-sidebar [(visible)]="verticalNavOpen" [ariaCloseLabel]="locales.common.close | localize" blockScroll="true">
	<ng-template udTemplate="headless">
		<ud-vertical-navigation
			[items]="merchantStore.items()"
			[menuHeading]="locales.common.menu | localize"
			[closeLabel]="locales.common.close | localize"
			[navigationLabel]="locales.common.navigation | localize"
			[loading]="!merchantStore.merchantLoaded()"
			resetMenuOnClose="true"
			(closeMenu)="verticalNavOpen.set(false)"
			(itemSelected)="itemSelected($event)"
		>
			@if (enableLogin()) {
				<ud-vertical-navigation-login [label]="locales.navigation.loginLabel | localize" />
			}
			@if (merchantStore.links().length) {
				@if (enableLogin()) {
					<ud-divider />
				}
				<ud-vertical-navigation-links
					[heading]="locales.navigation.links | localize"
					[items]="merchantStore.links()"
					[socialHandles]="merchantStore.socialHandles()"
				/>
			}
			@if (merchantStore.supportedLanguages().length > 1) {
				<ud-divider />
				<ud-vertical-navigation-language-selection
					[label]="locales.common.selectLanguage | localize"
					[selectedLanguage]="merchantStore.selectedLanguage() ? merchantStore.selectedLanguage() : merchantStore.defaultLanguage()"
					[supportedLanguages]="merchantStore.supportedLanguages()"
					(languageChanged)="merchantStore.setSelectedLanguage($event)"
				/>
			}
			<ng-template #footer>
				<div class="caption text-center">{{ copyright }}</div>
			</ng-template>
		</ud-vertical-navigation>
	</ng-template>
</ud-sidebar>
<ecom-footer
	class="mt-4"
	[copyright]="copyright"
	[navigationLinks]="merchantStore.footerLinks()"
	[iconLinks]="merchantStore.footerSocialLinks()"
	[languagesOffered]="merchantStore.supportedLanguagesList()"
	[activeLanguage]="merchantStore.selectedLanguage()"
	(languageChanged)="merchantStore.setSelectedLanguage($event)"
/>
